import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppAuthenticationReport } from 'src/app/models/app-authentication-report.model';
import { PaginatedResult } from '../model/paginated-result';

@Injectable({
  providedIn: 'root'
})
export class AppAuthenticationReportService {

  constructor(private http: HttpClient) { }

  getReport(
    startDate?: string,
    endDate?: string,
    email?: string,
    page: number = 1,
    perPage: number = 50
  ): Observable<PaginatedResult<AppAuthenticationReport[]>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('per_page', perPage.toString());

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    if (email) {
      params = params.set('email', email);
    }

    return this.http.get<PaginatedResult<AppAuthenticationReport[]>>(
      `${environment.apiUrl}/app-authentications`,
      { params }
    );
  }
}
